var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',[_c('section',{staticClass:"login"},[_c('div',{staticClass:"login-block"},[_c('logo'),_vm._v(" "),_c('login-form')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }